var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.origin)?_c('v-app',{attrs:{"id":"app"}},[_c('AlertBanner'),_c('LoadingOverlay'),_c('v-main',[(_vm.ready)?_c('v-container',[_c('router-view')],1):_c('div',{class:_vm.classes,style:(_vm.bg)})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }